import React, {useEffect, useRef, useState} from 'react';
import cn from 'classnames';
import classnames from 'classnames';
import './multiRangeSlider.style.scss';
import useCalculatePercent from './hook/useCalculatePercent';
import useDebounce from '../../utilities/hooks/useDebounce/useDebounce';

interface IRangeSlider {
  minVal: number;
  maxVal: number;
  min: number;
  max: number;
  setMinVal: (min: number) => void;
  setMaxVal: (max: number) => void;
  wrapperClass?: string;
}

const MultiRangeSlider = ({
  minVal,
  maxVal,
  setMinVal,
  setMaxVal,
  min,
  max,
  wrapperClass,
}: IRangeSlider) => {
  const [localMinVal, setLocalMinVal] = useState(minVal);
  const [localMaxVal, setLocalMaxVal] = useState(maxVal);

  const debouncedMinVal = useDebounce(localMinVal, 500);
  const debouncedMaxVal = useDebounce(localMaxVal, 500);

  const minValRef = useRef<HTMLInputElement>(null);
  const maxValRef = useRef<HTMLInputElement>(null);
  const range = useRef<HTMLDivElement>(null);
  useCalculatePercent(min, max, localMinVal, localMaxVal, maxValRef, range);

  useEffect(() => {
    setMinVal(debouncedMinVal);
  }, [debouncedMinVal]);

  useEffect(() => {
    setMaxVal(debouncedMaxVal);
  }, [debouncedMaxVal]);

  return (
    <div className={cn('wrapper', wrapperClass)}>
      <input
        type="range"
        min={min}
        max={max}
        value={localMinVal}
        ref={minValRef}
        onChange={event => {
          setLocalMinVal(event.target.valueAsNumber);
        }}
        className={classnames('thumb thumb--zindex-3', {
          'thumb--zindex-5': minVal > max - 100,
        })}
      />
      <input
        type="range"
        min={min}
        max={max}
        value={localMaxVal}
        ref={maxValRef}
        onChange={event => {
          setLocalMaxVal(event.target.valueAsNumber);
        }}
        className="thumb thumb--zindex-4"
      />

      <div className="slider" dir="ltr">
        <div className="slider__track" />
        <div ref={range} className="slider__range" />
      </div>
    </div>
  );
};

export default MultiRangeSlider;
